// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveCourseDeactivationChangeRequestStep1Handler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import CourseDeactivationChangeRequestDTO from '../models/CourseDeactivationChangeRequestDTO';
import ChangeRequestDTO from '../models/ChangeRequestDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    institutionId: string | null;
    courseDeactivationChangeRequest: CourseDeactivationChangeRequestDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            institutionId: '00000000-0000-0000-0000-000000000000',
            courseDeactivationChangeRequest: null,
        },
        initValues);
    },
    institutionId: 'institutionId',
    courseDeactivationChangeRequest: 'courseDeactivationChangeRequest',
}

interface Result extends ResultDTO {
    changeRequest: ChangeRequestDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            changeRequest: null,
        },
        initValues);
    },
    changeRequest: 'changeRequest',
}

export { Request, Result };